import { Displacer } from "./modules/displace";
import { Dropdown } from "./components/dropdown";
import { PopupManager } from "./components/popup";
import { TabManager } from "./components/tab";
import { AjaxFormMananger } from "./services/ajaxFormMananger";

require('jquery-ui/ui/core');
document.addEventListener('DOMContentLoaded', () => {
  /**
   * A NodeList containing all <details> elements and elements with the class name
   * specified by `js-dropdown`.
   *
   * @constant {NodeList} dropdowns
   */
  const dropdowns = document.querySelectorAll(`details, .${Dropdown.CLASS_NAMES.CONTAINER}`);
  for (let j = 0; j < dropdowns.length; j++) {
    const el = dropdowns[j];
    const dropdown = new Dropdown(el);
  }

  /**
   * A NodeList of all elements in the document with the attribute role="tablist".
   * Typically used to manage tabbed interfaces for accessibility.
   * @type {NodeListOf<Element>}
   */
  const tablists = document.getElementsByClassName(TabManager.CLASS_NAMES.TABLIST);
  for (let j = 0; j < tablists.length; j++) {
    const el = tablists[j];
    const tablist = new TabManager(el);
  }

})

window.addEventListener('load', () => {
  // Sets up the Displacer utility and exposes its methods and offsets on the global window object.
  const wpDisplacer = new Displacer();
  window.wpDisplace = wpDisplacer.displace;
  window.wpDisplace.calculateOffset = wpDisplacer.calculateOffset.bind(wpDisplacer);
  Object.defineProperty(window.wpDisplace, 'offsets', {
    value: wpDisplacer.offsets,
    writable: false,
  });


  new PopupManager();
  new AjaxFormMananger();
});
